import { z } from 'zod';

export const formSchema = z.object({
  loai_tscc: z.coerce.number(),
  ma_lts: z.string().nonempty('Mã loại là bắt buộc'),
  ten_lts: z.string().nonempty('Tên loại là bắt buộc'),
  ten_lts2: z.string().optional(),
  status: z.coerce.number().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  loai_tscc: 1,
  ma_lts: '',
  ten_lts: '',
  ten_lts2: '',
  status: 1
};
